// extracted by mini-css-extract-plugin
export default {"footerBg":"j-z","footerTopLinks":"k-z","footerFeedback":"l-z","footerSocial":"m-z","footerLegalLinks":"n-z","footerIconCards":"o-z","footerBotCopy":"p-z"};